// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TaiiT","colMin":"styles_colMin__Q_YiC"};